export enum ViewSearchParam {
  TrainingId = 'tId',
  TrainingSearch = 'tQuery',
  TrainingCategory = 'tCategory',
  TrainingType = 'tType',
  TrainingFrom = 'tFrom',
  TrainingTo = 'tTo'
}
